import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Constants } from './Constants';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { I18N } from 'ess-plugin-base';

@Injectable({
    providedIn: 'root'
})
export class SearchProvider {

    static resourceTypes: Map<string, ResourceType> = new Map<string, ResourceType>();

    constructor(private http: HttpClient, public i18n: I18N) {
    }

    public static registerResourceType(type: ResourceType) {
        SearchProvider.resourceTypes.set(type.namespace, type);
        return type;
    }

    public registerResourceType(type: ResourceType) {
        SearchProvider.resourceTypes.set(type.namespace, type);
        return type;
    }

    public getTitle(namespace: string): string {
        let type = SearchProvider.resType(namespace);
        if (type.name) {
            return this.i18n.get(namespace, type.name);
        } else {
            return '';
        }
    }

    public getIcon(namespace: string): string {
        let type = SearchProvider.resType(namespace);
        //console.log('Icon of ' + namespace + ' is ', type)
        return type.icon;
    }

    public static resType(namespace: string) {
        let type = this.resourceTypes.get(namespace);
        if (!type) {
            type = new ResourceType();
            type.name = '';
            type.name_en = '';
            type.icon = '';
        }
        return type;
    }

    public getResources(q: string, limit: number, match: MatchType, tolerance: number): Observable<any[]> {
        let url = Constants.protocol + Constants.nameServer + "/name/search";
        
        let params = new HttpParams();
        params = params.append('q', q);
        params = params.append('limit', "" + (limit || 100));
        if (match)
            params = params.append('match', "" + match);
        if (tolerance)
            params = params.append('tolerance', "" + tolerance);

        return this.http.get(url + '?' + params, Constants.httpOptions)
        .pipe(
            tap((response: any) => {
            
              let res = (response && response.resources)? response.resources : [];
              return res;
            })
        );
    }
}

export class ResourceType {

    public name: string;
    public name_en: string;
    public namespace: string;
    public icon: string;

    // public getLabel(namespace: any, lang: string = 'en'): string {
    //     if (lang == 'en') {
    //         let def = this.name_en || this.name || this.namespace;
    //         return this.i18n
    //     } else {
    //         return 
    //     }
    //     return label;
    // }
}

export enum MatchType {
    EXACT = "exact",
    START = "start",
    PARTIAL = "partial"
}